import { render, staticRenderFns } from "./btn-redirect.vue?vue&type=template&id=2350fe84&scoped=true"
import script from "./btn-redirect.vue?vue&type=script&lang=js"
export * from "./btn-redirect.vue?vue&type=script&lang=js"
import style0 from "./btn-redirect.vue?vue&type=style&index=0&id=2350fe84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2350fe84",
  null
  
)

export default component.exports